import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import Loader from '../Loader';
import AddPhoneNumberForm from './AddPhoneNumberForm';
import VerifyPhoneNumberForm from './VerifyPhoneNumberForm';

import { openSmsVerificationModal, closeSmsVerificationModal } from '../../actions/SmsVerification/modalActions';
import { sendVerificationSms } from '../../actions/SmsVerification/sendVerificationSms';
import { decode } from '../../helpers/queryEncryption'
import getUserDataQuery from './getUserData.graphql';
import showToaster from '../../helpers/showToaster';
import messages from '../../locale/messages';
import showErrorMessage from '../../helpers/showErrorMessage';
import { PRIMARY_COLOR, DARK_PRIMARY_COLOR } from '../../constants'
import { withMutation, withQuery } from '../../hoc/withGraphql';

import s from './PhoneVerificationModal.css';
import bt from '../../components/commonStyle.css';

class PhoneVerificationModal extends Component {

  static propTypes = {
    formatMessage: PropTypes.any,
    data: PropTypes.object
  };

  static defaultProps = {
    modalStatus: false,
    data: {
      getPhoneData: null,
      loading: false
    },
    modalFormType: 'addPhoneNumber'
  }

  constructor(props) {
    super(props);

    this.state = {
      form1: true,
      form2: false,
      buttonLoader: false
    };

    this.verifyPhoneNumber = this.verifyPhoneNumber.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.renderAddPhoneNumber = this.renderAddPhoneNumber.bind(this);
    this.renderVerifyPhoneNumber = this.renderVerifyPhoneNumber.bind(this);
    this.formatPhoneNumber = this.formatPhoneNumber.bind(this);
    this.renderConfirmedPhoneNumber = this.renderConfirmedPhoneNumber.bind(this);
    this.handleRemove = this.handleRemove.bind(this);

  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { modalStatus, modalFormType } = nextProps;
    if (modalFormType == 'verifyPhoneNumber') {
      this.setState({
        form1: false,
        form2: true
      });
    } else {
      this.setState({
        form1: true,
        form2: false
      });
    }
  }


  async verifyPhoneNumber() {
    const { sendVerificationSms, data, data: { loading, getPhoneData }, userId } = this.props;

    let error;
    if (!loading && getPhoneData) {
      this.setState({ buttonLoader: true });
      const { status, errorMessage } = await sendVerificationSms(getPhoneData.countryCode, decode(getPhoneData.phoneNumber), getPhoneData?.countryName, userId);
      if (status != '200') {
        if (errorMessage) {
          error = errorMessage;
        } else {
          error = await showErrorMessage({ errorCode: 'commonError' })
        }
        showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: error })
      }
      this.setState({ buttonLoader: false });
    }

  }

  async handleClick(formType) {
    const { openSmsVerificationModal, modalStatus } = this.props;
    openSmsVerificationModal(formType);
  }

  async handleRemove() {
    const { mutate, closeSmsVerificationModal, userId, account } = this.props;
    let id = userId ? userId : account?.userId;

    await mutate({
      variables: { userId: id },
      refetchQueries: [{
        query: getUserDataQuery, variables: { userId: id },
        fetchPolicy: 'network-only',
      }]
    });

    await closeSmsVerificationModal();
  }

  formatPhoneNumber(phoneNumber) {
    let formattedNumber = '';
    if (phoneNumber && phoneNumber != '') {
      if (phoneNumber.length > 6) {
        formattedNumber = phoneNumber.substr(0, phoneNumber.length - 3);
        formattedNumber = formattedNumber.replace(new RegExp("\\d", "g"), '*');
        formattedNumber = formattedNumber + phoneNumber.substr(phoneNumber.length - 3, phoneNumber.length);
      } else {
        formattedNumber = '***' + formattedNumber + phoneNumber.substr(phoneNumber.length - 1, phoneNumber.length);
      }
    }

    return formattedNumber;
  }

  renderAddPhoneNumber() {
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <p className={cx(s.labelText)}>
          <FormattedMessage {...messages.noPhoneNumberEntered} /></p>
        <a href="javascript:void(0)" className={cx(s.modalCaptionLink)}
          onClick={() => this.handleClick('addPhoneNumber')}>
          <span >&#43;</span>
          <FormattedMessage {...messages.addPhoneNumber} />
        </a>
      </div>
    )
  }

  renderVerifyPhoneNumber() {
    const { data, data: { loading, getPhoneData }, theme } = this.props;
    const { formatMessage } = this.props.intl;
    const { buttonLoader } = this.state;

    return (
      <div>
        <table className={s.tableBox}>
          <tbody>
            <tr>
              {
                !loading && <th className={cx(s.tableBoxHeader)}>
                  {getPhoneData.countryCode + ' ' + this.formatPhoneNumber(decode(getPhoneData.phoneNumber))}
                </th>
              }
              <td>
                <Loader
                  type={"button"}
                  buttonType={"button"}
                  className={cx(bt.btnPrimaryBorder, bt.loaderButtonFlex)}
                  disabled={buttonLoader}
                  show={buttonLoader}
                  label={formatMessage(messages.verifyViaSms)}
                  handleClick={this.verifyPhoneNumber}
                  spinnerColor={theme === 'dark' ? DARK_PRIMARY_COLOR : PRIMARY_COLOR}
                />
              </td>
              <td className={cx('text-right', 'textAlignLeftRtl')}>
                <a href="javascript:void(0)"
                  className={cx(s.modalCaptionLink)}
                  title="Remove"
                  onClick={this.handleRemove}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" className={s.iconSize}>
                    <path d="M2.89118 2.0027C2.72252 2.00429 2.55809 2.05572 2.41855 2.15051C2.27902 2.2453 2.1706 2.37923 2.10692 2.53547C2.04324 2.69171 2.02715 2.86329 2.06066 3.02866C2.09417 3.19402 2.17579 3.34579 2.29526 3.4649L8.79082 9.97728L2.28064 16.4762C2.1949 16.554 2.12583 16.6485 2.07764 16.7538C2.02945 16.8591 2.00312 16.9731 2.00026 17.0889C1.9974 17.2047 2.01806 17.3199 2.061 17.4274C2.10394 17.535 2.16825 17.6327 2.25005 17.7147C2.33185 17.7967 2.42944 17.8612 2.53689 17.9044C2.64435 17.9475 2.75944 17.9684 2.8752 17.9658C2.99096 17.9631 3.10498 17.937 3.21035 17.889C3.31572 17.841 3.41026 17.7721 3.48823 17.6864L9.99841 11.1875L16.494 17.701C16.5702 17.7909 16.6643 17.8641 16.7701 17.9158C16.876 17.9676 16.9915 17.9969 17.1092 18.0019C17.227 18.0069 17.3445 17.9875 17.4544 17.9449C17.5642 17.9023 17.6641 17.8374 17.7477 17.7543C17.8313 17.6712 17.8969 17.5717 17.9402 17.4621C17.9835 17.3524 18.0037 17.235 17.9994 17.1172C17.9952 16.9994 17.9667 16.8837 17.9156 16.7775C17.8645 16.6712 17.792 16.5767 17.7027 16.4998L11.2071 9.98741L17.7139 3.48627C17.7965 3.40773 17.8625 3.31347 17.9081 3.20904C17.9537 3.10461 17.978 2.99211 17.9795 2.87816C17.981 2.76421 17.9597 2.65111 17.9169 2.54551C17.8741 2.43991 17.8106 2.34394 17.7301 2.26325C17.6497 2.18255 17.5539 2.11876 17.4485 2.07563C17.343 2.03249 17.23 2.01089 17.1161 2.01208C17.0022 2.01327 16.8897 2.03723 16.7851 2.08256C16.6806 2.12789 16.5862 2.19366 16.5075 2.27602L9.99729 8.77491L3.5006 2.2614C3.42133 2.1799 3.3266 2.11504 3.22195 2.07062C3.11731 2.02619 3.00486 2.00311 2.89118 2.0027Z" fill="currentColor" />
                  </svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderConfirmedPhoneNumber() {
    const { data, data: { loading, getPhoneData }, userId } = this.props;

    return (
      <div>
        <table className={s.tableBox}>
          <tbody>
            <tr>
              {
                !loading && <th className={cx(s.tableBoxHeader)}>
                  {getPhoneData.countryCode + ' ' + this.formatPhoneNumber(decode(getPhoneData.phoneNumber))}
                </th>
              }
              <td>
                <p className={cx(s.confirmedText)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" className={cx(s.confirmedIcon)}>
                    <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" fill="currentColor" />
                    <path d="M13.6991 7.38845C13.6419 7.33128 13.5741 7.28593 13.4994 7.25499C13.4248 7.22405 13.3448 7.20813 13.2639 7.20813C13.1831 7.20813 13.1031 7.22405 13.0284 7.25499C12.9538 7.28593 12.886 7.33128 12.8288 7.38845L8.9115 11.3076L7.17106 9.56445C7.05566 9.44905 6.89914 9.38422 6.73595 9.38422C6.57275 9.38422 6.41623 9.44905 6.30083 9.56445C6.18544 9.67985 6.12061 9.83636 6.12061 9.99956C6.12061 10.1628 6.18544 10.3193 6.30083 10.4347L8.47595 12.6116C8.53307 12.6687 8.6009 12.7141 8.67556 12.745C8.75022 12.776 8.83024 12.7919 8.91106 12.7919C8.99187 12.7919 9.0719 12.776 9.14656 12.745C9.22121 12.7141 9.28904 12.6687 9.34617 12.6116L13.7017 8.25601C13.816 8.1404 13.8799 7.98424 13.8794 7.82168C13.8789 7.65911 13.8141 7.50335 13.6991 7.38845Z" fill="white" />
                  </svg>
                  <FormattedMessage {...messages.confirmedLabel} />
                </p>
              </td>
              <td className={cx('text-right', 'textAlignLeftRtl')}>
                <a href="javascript:void(0)"
                  className={cx(s.modalCaptionLink)}
                  title="Remove"
                  onClick={this.handleRemove}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" className={s.iconSize}>
                    <path d="M2.89118 2.0027C2.72252 2.00429 2.55809 2.05572 2.41855 2.15051C2.27902 2.2453 2.1706 2.37923 2.10692 2.53547C2.04324 2.69171 2.02715 2.86329 2.06066 3.02866C2.09417 3.19402 2.17579 3.34579 2.29526 3.4649L8.79082 9.97728L2.28064 16.4762C2.1949 16.554 2.12583 16.6485 2.07764 16.7538C2.02945 16.8591 2.00312 16.9731 2.00026 17.0889C1.9974 17.2047 2.01806 17.3199 2.061 17.4274C2.10394 17.535 2.16825 17.6327 2.25005 17.7147C2.33185 17.7967 2.42944 17.8612 2.53689 17.9044C2.64435 17.9475 2.75944 17.9684 2.8752 17.9658C2.99096 17.9631 3.10498 17.937 3.21035 17.889C3.31572 17.841 3.41026 17.7721 3.48823 17.6864L9.99841 11.1875L16.494 17.701C16.5702 17.7909 16.6643 17.8641 16.7701 17.9158C16.876 17.9676 16.9915 17.9969 17.1092 18.0019C17.227 18.0069 17.3445 17.9875 17.4544 17.9449C17.5642 17.9023 17.6641 17.8374 17.7477 17.7543C17.8313 17.6712 17.8969 17.5717 17.9402 17.4621C17.9835 17.3524 18.0037 17.235 17.9994 17.1172C17.9952 16.9994 17.9667 16.8837 17.9156 16.7775C17.8645 16.6712 17.792 16.5767 17.7027 16.4998L11.2071 9.98741L17.7139 3.48627C17.7965 3.40773 17.8625 3.31347 17.9081 3.20904C17.9537 3.10461 17.978 2.99211 17.9795 2.87816C17.981 2.76421 17.9597 2.65111 17.9169 2.54551C17.8741 2.43991 17.8106 2.34394 17.7301 2.26325C17.6497 2.18255 17.5539 2.11876 17.4485 2.07563C17.343 2.03249 17.23 2.01089 17.1161 2.01208C17.0022 2.01327 16.8897 2.03723 16.7851 2.08256C16.6806 2.12789 16.5862 2.19366 16.5075 2.27602L9.99729 8.77491L3.5006 2.2614C3.42133 2.1799 3.3266 2.11504 3.22195 2.07062C3.11731 2.02619 3.00486 2.00311 2.89118 2.0027Z" fill="currentColor" />
                  </svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }


  render() {
    const { formatMessage } = this.props.intl;
    const { openSmsVerificationModal, closeSmsVerificationModal, modalStatus, sendVerificationSms } = this.props;
    const { data, data: { loading, getPhoneData }, userId, account } = this.props;
    let id = userId ? userId : account?.userId;
    const { form1, form2, buttonLoader } = this.state;
    let verificationStatus = (getPhoneData && getPhoneData.verification && getPhoneData.verification.isPhoneVerified == true) ? true : false;

    return (

      <div>
        {
          loading && <Loader show={true} />
        }
        {
          !loading && getPhoneData && !modalStatus && !getPhoneData.phoneNumber && !verificationStatus && <div>
            {
              this.renderAddPhoneNumber()
            }
          </div>
        }
        {
          !loading && getPhoneData && !modalStatus && getPhoneData.phoneNumber && !verificationStatus && <div>
            {
              this.renderVerifyPhoneNumber()
            }
          </div>
        }

        {

          !loading && getPhoneData && modalStatus && !verificationStatus && form1 && <div className={s.formContainer}>
            <AddPhoneNumberForm userId={id} />
          </div>
        }
        {
          !loading && getPhoneData && modalStatus && !verificationStatus && form2 && <div className={s.formContainer}>
            <VerifyPhoneNumberForm
              countryCode={getPhoneData.countryCode}
              phoneNumber={decode(getPhoneData.phoneNumber)}
              userId={id}
            />
          </div>
        }
        {
          !loading && verificationStatus && <div>
            {
              this.renderConfirmedPhoneNumber()
            }
          </div>
        }
      </div>
    );
  }

}

const mapState = state => ({
  modalStatus: state.modalStatus.smsVerificationModalOpen,
  modalFormType: state.modalStatus.formType,
  account: state?.account?.data,
  theme: state?.currency?.theme
});

const mapDispatch = {
  openSmsVerificationModal,
  closeSmsVerificationModal,
  sendVerificationSms
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(getUserDataQuery, {
    options: (props) => ({
      variables: {
        userId: props.userId,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }

  ),
  withMutation(gql`
    mutation RemovePhoneNumber($userId:String) {
        RemovePhoneNumber(userId:$userId) {
            status
        }
    }`
  )
)(PhoneVerificationModal);
